// Password validation helpers - run only when fields exist and jQuery is available
document.addEventListener('turbo:load', () => {
  if (typeof window.$ === 'undefined') return; // jQuery not present

  var $password = $("#password");
  var $confirmPassword = $("#confirm_password");

  // If the page has no password fields, skip
  if ($password.length === 0 && $confirmPassword.length === 0) return;

  //Hide hints (scoped to the form containing the password inputs, if any)
  var $form = $password.closest('form');
  if ($form.length) {
    $form.find('span').hide();
  } else {
    $("form span").hide();
  }

  function isPasswordValid() {
    var val = ($password.val() || "");
    return val.length > 5;
  }

  function arePasswordsMatching() {
    var p = ($password.val() || "");
    var c = ($confirmPassword.val() || "");
    return p === c;
  }

  function canSubmit() {
    return isPasswordValid() && arePasswordsMatching();
  }

  function passwordEvent() {
    if ($password.length === 0) return;
    if (isPasswordValid()) {
      $password.next().hide();
    } else {
      $password.next().show();
    }
  }

  function confirmPasswordEvent() {
    if ($confirmPassword.length === 0) return;
    if (arePasswordsMatching()) {
      $confirmPassword.next().hide();
    } else {
      $confirmPassword.next().show();
    }
  }

  function enableSubmitEvent() {
    $("#submit").prop("disabled", !canSubmit());
  }

  // Bind events (they no-op if the element is missing)
  if ($password.length) {
    $password
      .on('focus', passwordEvent)
      .on('keyup', passwordEvent)
      .on('keyup', confirmPasswordEvent)
      .on('keyup', enableSubmitEvent);
  }
  if ($confirmPassword.length) {
    $confirmPassword
      .on('focus', confirmPasswordEvent)
      .on('keyup', confirmPasswordEvent)
      .on('keyup', enableSubmitEvent);
  }

  enableSubmitEvent();
});
// end password check
